import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.3753 5.17246L10.672 4.12427L5.20996 13H11.21L7.62377 18.8276L9.32709 19.8758L14.7891 11H8.78909L12.3753 5.17246Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0 5H8.37178L2.52561 14.5H8.52561L5.7564 19H0V5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 19H11.6273L17.4734 9.50002H11.4734L14.2427 5H21V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 9V15H22V9H24Z"}}]};

const BatteryChargingFilled = Vue.extend<IconProps>({
  name: 'BatteryChargingFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'battery-charging-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default BatteryChargingFilled;
